import { render, staticRenderFns } from "./Value.vue?vue&type=template&id=8f0f0828"
import script from "./Value.vue?vue&type=script&lang=js"
export * from "./Value.vue?vue&type=script&lang=js"
import style0 from "./Value.vue?vue&type=style&index=0&id=8f0f0828&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports